// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/b5e0634716437797c49f.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"ff0c98cbc00ee8f8a6c7","216":"25deaccf8a34e9e84f64","217":"dba1f5352bf1f3b8ff0c"}[chunkId] + ".chunk.js";
};